import React, { Component } from 'react';

//views
import CariLoginPanel from "../../components/cari_components/CariLoginPanel";

//router
import { NavLink } from 'react-router-dom';

//generic functions
import {
    fetchCariOutageMessages
} from "../../../../functions/generic_functions";

//static routes
import {
    cari_home_pg_url,
    cari_api_load_outage_banner_url
} from "../../../../router/static_routes";

import AlertBannerBlock from "../../../../generic_components/components/text_display/AlertBannerBlock";

/*
    props:
        siteTitle : title of the header
*/
class CariMainPgLoggedInHeaderView extends Component {
    state = {
        outageMessages: [],
    }

    constructor(props) {
        super(props);
        this.loadOutageBannerFromApi = this.loadOutageBannerFromApi.bind(this);
    }

    loadOutageBannerFromApi() {
        fetchCariOutageMessages(cari_api_load_outage_banner_url).then((fetchedOutageMessages) => {
            this.setState({
                outageMessages: fetchedOutageMessages,
            });
        }).catch((error) => {
            console.log(error);
        });
    }

    componentDidMount() {
        this.loadOutageBannerFromApi();
    }

    render() {
        var outageMessages = this.props.outageMessages;

        return (
            <div>
                <header className="logged_in_header_style">
                    <section className='logged_in_header_background'>
                        <div className='brand-title'>

                            <NavLink to={cari_home_pg_url}>
                                <div className='branding'>
                                    <h1 className="">
                                        Beedie School of Business
                                    </h1>
                                </div>
                            </NavLink>

                            <div className='site-title'>
                                <h2 className="site_header_title_font_color">
                                    {this.props.siteTitle}
                                </h2>
                            </div>
                        </div>
                    </section>

                    {/* {<span className="pull_right">
                        <CariLoginPanel />
                    </span> } */}
                </header>
                  {this.state.outageMessages && this.state.outageMessages.length > 0 ? (
                    <AlertBannerBlock messages={this.state.outageMessages} alertType="danger" />  
                ) : null}
            </div>
        );
    }
}

export default CariMainPgLoggedInHeaderView;